
import { BUSINESS_UNIT_METADATA } from '../../businessunit/model/business-unit.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class SystemMessageMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('SystemMessage', {
      id: <PropertyMetadata> {
        name: 'id',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        precision: 8,
        unique: true
      },
      businessUnit: <PropertyMetadata> {
        name: 'businessUnit',
        type: 'BusinessUnit',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return BUSINESS_UNIT_METADATA;
        },
        byReference: true,
        unique: false
      },
      expirationDate: <PropertyMetadata> {
        name: 'expirationDate',
        type: 'Date',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      expiryDate: <PropertyMetadata> {
        name: 'expiryDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      linkData: <PropertyMetadata> {
        name: 'linkData',
        type: '{ [id: string]: any; }',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      message: <PropertyMetadata> {
        name: 'message',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 512,
        unique: false
      },
      uniqueId: <PropertyMetadata> {
        name: 'uniqueId',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      userMessageType: <PropertyMetadata> {
        name: 'userMessageType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.id;
    return nullIfContainsNull(result);
  }
}



